export default __webpack_public_path__ + "fee617d635f86384635537ca9d1d4c0a.png";